import React from 'react';

// Picker simple qui reflète visuellement le nombre de caméras
// et met à jour cameraLayout au clic.
const CameraLayoutPicker = ({ cameraLayout, setCameraLayout }) => {
  const layouts = [
    { value: 1, cols: 1, rows: 1, label: "1 caméra" },
    { value: 2, cols: 2, rows: 1, label: "2 caméras" },
    { value: 4, cols: 2, rows: 2, label: "4 caméras" },
    { value: 6, cols: 3, rows: 2, label: "6 caméras", isBento: true },
    { value: 9, cols: 5, rows: 5, label: "9 caméras", isBento: true },
    { value: 16, cols: 4, rows: 4, label: "16 caméras" }
  ];

  return (
    <div className="flex items-center gap-2 p-2 bg-gray-100 rounded-lg">
      {layouts.map((layout) => {
        const isSelected = cameraLayout === layout.value;
        const totalItems = layout.cols * layout.rows;
        
        return (
          <div key={layout.value} className="relative">
            <input
              type="radio"
              id={`layout-${layout.value}`}
              name="camera-layout"
              value={layout.value}
              checked={isSelected}
              onChange={() => setCameraLayout(layout.value)}
              className="hidden"
              aria-label={layout.label}
            />
            
            <label
              htmlFor={`layout-${layout.value}`}
              className={`
                flex items-center justify-center
                w-10 h-7
                p-1
                rounded-md
                cursor-pointer
                transition-all
                duration-200
                ${isSelected 
                  ? 'bg-blue-50 border-2 border-blue-500' 
                  : 'bg-white border border-gray-300'}
                hover:border-blue-400 hover:scale-105
              `}
              title={layout.label}
            >
              {/* Aperçu des grilles : simple (1/2/4/16) ou bento (6/9) */}
              {layout.isBento && layout.value === 6 ? (
                <div className="grid grid-cols-5 grid-rows-5 gap-0.5 w-full h-full">
                  {/* Grand bloc principal (2x2) */}
                  <div
                    className={`
                      col-span-2 row-span-2 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 2 */}
                  <div
                    className={`
                      col-start-1 row-start-3 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 3 */}
                  <div
                    className={`
                      col-start-2 row-start-3 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 4 */}
                  <div
                    className={`
                      col-start-3 row-start-3 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 5 */}
                  <div
                    className={`
                      col-start-3 row-start-2 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 6 */}
                  <div
                    className={`
                      col-start-3 row-start-1 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                </div>
              ) : layout.isBento && layout.value === 9 ? (
                <div className="grid grid-cols-5 grid-rows-5 gap-0.5 w-full h-full">
                  {/* Grand bloc principal (3x4) */}
                  <div
                    className={`
                      col-span-3 row-span-4 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 2 */}
                  <div
                    className={`
                      col-start-1 row-start-5 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 3 */}
                  <div
                    className={`
                      col-start-2 row-start-5 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 4 */}
                  <div
                    className={`
                      col-start-4 row-start-1 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 5 */}
                  <div
                    className={`
                      col-start-4 row-start-2 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 6 */}
                  <div
                    className={`
                      col-start-3 row-start-5 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 7 */}
                  <div
                    className={`
                      col-start-4 row-start-3 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 8 */}
                  <div
                    className={`
                      col-start-4 row-start-5 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                  {/* Bloc 9 */}
                  <div
                    className={`
                      col-start-4 row-start-4 rounded-sm
                      ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                      ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                      transition-colors
                      duration-150
                    `}
                  />
                </div>
              ) : (
                <div
                  className={`
                    grid
                    gap-0.5
                    w-full h-full
                    ${`grid-cols-${layout.cols}`}
                  `}
                  style={{ gridTemplateRows: `repeat(${layout.rows}, minmax(0, 1fr))` }}
                >
                  {Array.from({ length: totalItems }).map((_, index) => (
                    <div
                      key={index}
                      className={`
                        rounded-sm
                        ${isSelected ? 'bg-blue-500' : 'bg-gray-400'}
                        ${isSelected ? 'hover:bg-blue-600' : 'hover:bg-blue-300'}
                        transition-colors
                        duration-150
                      `}
                    />
                  ))}
                </div>
              )}
              
              {isSelected && (
                <div className="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 bg-blue-500 rounded-full text-white text-xs">
                  ✓
                </div>
              )}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default CameraLayoutPicker;
